<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="inspectionItem.pkId > 0 ? '编辑' : '新建'"
      class="employee-edit"
      width="900px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        :model="inspectionItem"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="编号">
            <el-input v-model="inspectionItem.no" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="检验方法">
            <el-radio-group v-model="inspectionItem.inspectionMethod">
              <el-radio :label="0">全检</el-radio>
              <el-radio :label="1">免检</el-radio>
              <el-radio :label="2">抽检</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="名称" prop="name">
            <el-input v-model="inspectionItem.name" placeholder="请输入"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="类别" prop="inspectionCategory">
            <el-select v-model="inspectionItem.inspectionCategory">
              <el-option value="包装"/>
              <el-option value="附件"/>
              <el-option value="外观"/>
              <el-option value="尺寸"/>
              <el-option value="性能"/>
              <el-option value="其它"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="检验标准">
            <el-input v-model="inspectionItem.inspectionStandard" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="最大值">
            <el-input v-model="inspectionItem.maxValue" placeholder="请输入"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="最小值">
            <el-input v-model="inspectionItem.minValue" placeholder="请输入"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="单位">
            <el-input v-model.trim="inspectionItem.unit" placeholder="请输入"/>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="标准值">
            <el-input v-model.trim="inspectionItem.standardValue" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="描述">
          <el-input v-model="inspectionItem.note" type="textarea" placeholder="请输入"/>
        </el-form-item>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import constants from "../../../util/constants";

  export default {
    name: "InspectionEdit",
    data() {
      return {
        constants,
        positionList: [],
        dialogVisible: false,
        submitLoading: false,
        inspectionItem: {
          pkId: 0,
          no: "",
          name: "",
          inspectionStandard: "",
          inspectionTools: "",
          standardValue: "",
          maxValue: "",
          minValue: "",
          unit: "",
          inspectionMethod: 2,
          note: "",
          inspectionCategory: "包装",
        },
        ruleValidate: {
          name: {required: true, message: "请输入名称", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.inspectionItem.pkId = row.pkId;
          this.getData();
        } else {
          this.getNode();
        }
      },
      // 根据id查询信息
      getData() {
        this.$http.get("basic", `inspectionItems/${this.inspectionItem.pkId}`).then((resp) => {
          console.log(resp);
          if (resp.success) {
            this.inspectionItem = resp.data;
          }
        });
      },
      // 获取编号
      getNode() {
        this.$http.get("basic", "inspectionItems/getNo").then((resp) => {
          if (resp.success) {
            this.inspectionItem.no = resp.data;
          }
        });
      },

      // 提交
      submit() {
        if (this.inspectionItem.pkId > 0) {
          this.handleSubmitUpdData();
        } else {
          this.handleSubmitSave();
        }
      },

      // 编辑
      handleSubmitUpdData() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
                .put("basic", "inspectionItems", this.inspectionItem)
                .then((resp) => {
                  if (resp.success) {
                    this.submitLoading = false;
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  }
                  this.submitLoading = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
          }
        });
      },

      // 新建
      handleSubmitSave() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
                .post("basic", "inspectionItems", this.inspectionItem)
                .then((resp) => {
                  if (resp.success) {
                    this.submitLoading = false;
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.submitLoading = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
          }
        });
      },
    },
  };
</script>
